import { FC, useEffect, useState } from "react";
import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import React from "react";
import Section from "./Section";
import CustomSkeleton from "src/components/skeleton/Skeleton";

type ThemeCardProps = {
  isFetching: boolean;
  title: string | null;
  themeType: string | null;
  fieldList: any[];
  jsonData: any;
  onChange: any;
  fontSizeOptions: any[];
  fontFamilyOptions: any[];
  fontWeightOptions: any[];
  iconSizeOptions: any[];
  fieldsData: any | null;
  isDarkMode: boolean;
  handleCustomDataChange: any;
};

const ThemeCard: FC<ThemeCardProps> = (props) => {
  const { isFetching, title, themeType, fieldList, jsonData, onChange, fontSizeOptions, fontFamilyOptions, fontWeightOptions, iconSizeOptions, fieldsData, isDarkMode, handleCustomDataChange } = props;
  const [distinctAccordions, setDistinctAccordions] = useState<string[]>([]);

  useEffect(() => {
    const accordions = [...new Set(fieldList.map((picker: any) => picker.category))];
    setDistinctAccordions(accordions);
  }, [fieldList, title]);

  const filterFields = (accordion: string) => {
    return fieldList
      .filter((field: any) => field.category === accordion)
      .map((field: any) => {
        if (!field.hasData || !field.data || field.data.length === 0) {
          return field; // Include fields without data
        }
  
        const filteredData = field.data.filter((dataItem: any) => {
          return isDarkMode ? Boolean(dataItem.IsDark) === true : Boolean(dataItem.IsDark) === false;
        });
  
        return { ...field, data: filteredData }; // Return the field with filtered data
      })
      .filter((field: any) => {
        return !field.data || field.data.length > 0 || !field.hasData; // Include fields without data or hasData key
      });
  };

  return (
    <>
      <Card sx={{ marginBottom: '2%' }}>
        <CardContent>
          {isFetching ? <CustomSkeleton skeletonType="FormEdit" /> : (
            <Box>
              <Grid container alignItems="center" justifyContent="space-between">
                <Typography variant="h5" sx={{ paddingBottom: 1 }}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    {title}
                  </Box>
                </Typography>
              </Grid>
              {distinctAccordions && distinctAccordions.length > 0 && !isFetching && distinctAccordions.map((accordion, idx) => {
                const filteredFields = filterFields(accordion);
                if (filteredFields.length === 0) {
                  return null; // Skip this accordion if no fields match the filter
                }
                return (
                  <React.Fragment key={`${accordion}-${idx}`}>
                    <Section
                      title={accordion}
                      idx={idx}
                      fields={filteredFields}
                      jsonData={jsonData}
                      onChange={onChange}
                      fontSizeOptions={fontSizeOptions}
                      fontFamilyOptions={fontFamilyOptions}
                      fontWeightOptions={fontWeightOptions}
                      iconSizeOptions={iconSizeOptions}
                      themeType={themeType}
                      fieldsData={fieldsData}
                      handleCustomDataChange={handleCustomDataChange}
                    />
                  </React.Fragment>
                );
              })}
            </Box>
          )}
        </CardContent>
      </Card>
    </>
  )
};

export default ThemeCard;
